import { apiClient } from './client'
import type { AuthorRef } from './types'

/** Phase 19 — admin seed-review API. Gated by handle list server-side. */

export interface SeedProject {
  id: string
  title: string
  description: string | null
  slug: string
  heroThumbUrl: string | null
  generationSource: string | null
  author: AuthorRef
  createdAt: string
  updatedAt: string
}

export const listSeedProjects = async (): Promise<SeedProject[]> => {
  const response = await apiClient.get<SeedProject[]>('/api/v1/admin/seed-projects')
  return response.data
}

export const publishSeedProject = async (id: string): Promise<void> => {
  await apiClient.post(`/api/v1/admin/seed-projects/${id}/publish`)
}

export const discardSeedProject = async (id: string): Promise<void> => {
  await apiClient.delete(`/api/v1/admin/seed-projects/${id}`)
}
